import React from "react";
import "../../node_modules/react-vis/dist/style.css";
import {
  XYPlot,
  XAxis,
  YAxis,
  makeVisFlexible,
  VerticalGridLines,
  HorizontalGridLines,
  VerticalBarSeries,
} from "react-vis";

const BarDashboard = (props) => {
  const BarSeries = VerticalBarSeries;
  const FlexibleXYPlot = makeVisFlexible(XYPlot);

  return (
    <FlexibleXYPlot
      color="#07948D"
      xType="ordinal"
      margin={{ left: 60 }}
      xDistance={100}
    >
      <VerticalGridLines />
      <HorizontalGridLines />
      <XAxis tickValues={props.ticks} />
      <YAxis tickFormat={props.format} />
      <BarSeries data={props.data} />
    </FlexibleXYPlot>
  );
};
export default BarDashboard;
